/**
 * @generated SignedSource<<74bcf6f7cb8d71f7a3f1a77cd270a56a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCourseDisplayName_course$data = {
  readonly facility: {
    readonly courses: {
      readonly count: number;
    } | null | undefined;
    readonly name: string;
  };
  readonly name: string;
  readonly " $fragmentType": "useCourseDisplayName_course";
};
export type useCourseDisplayName_course$key = {
  readonly " $data"?: useCourseDisplayName_course$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCourseDisplayName_course">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCourseDisplayName_course",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "archived",
              "value": false
            }
          ],
          "concreteType": "CourseConnection",
          "kind": "LinkedField",
          "name": "courses",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            }
          ],
          "storageKey": "courses(archived:false)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Course",
  "abstractKey": null
};
})();

(node as any).hash = "98b4ce5a508154f5811ccd5980cf0f43";

export default node;
